var _path, _path2, _ellipse, _ellipse2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoursePreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.723 8.89c0-1.043 0-1.8.04-2.398.041-.595.12-.997.26-1.334a3.944 3.944 0 0 1 2.135-2.135c.337-.14.74-.219 1.334-.26.598-.04 1.355-.04 2.397-.04h12.223c2.595 0 4.517 0 6.045.104 1.524.104 2.62.31 3.57.703a10.611 10.611 0 0 1 5.744 5.743c.393.95.599 2.047.703 3.57.104 1.53.104 3.45.104 6.046v12.223c0 1.042 0 1.799-.04 2.397-.041.595-.12.997-.26 1.334a3.945 3.945 0 0 1-2.135 2.135c-.337.14-.74.218-1.334.26-.599.04-1.355.04-2.398.04H18.89c-2.595 0-4.517 0-6.045-.104-1.524-.104-2.621-.31-3.57-.703a10.611 10.611 0 0 1-5.744-5.743c-.393-.95-.599-2.047-.703-3.571-.104-1.529-.104-3.45-.104-6.046V8.89Z",
  fill: "#F2F6FD",
  stroke: "#DFE9F9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7 20a2.12 2.12 0 0 1 2.113-2.125h5.093c3.025 0 5.478 2.466 5.478 5.507 0 3.042-2.453 5.508-5.478 5.508h-1.633a2.12 2.12 0 0 1-2.114-2.126 2.12 2.12 0 0 1 2.114-2.126h1.633c.69 0 1.25-.562 1.25-1.256 0-.693-.56-1.256-1.25-1.256h-5.093a2.12 2.12 0 0 1-2.114-2.125Z",
  fill: "#BBCEEE"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.8,
  cx: 14.891,
  cy: 13.237,
  rx: 2.114,
  ry: 2.126,
  fill: "#BBCEEE"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.8,
  cx: 14.891,
  cy: 26.763,
  rx: 2.114,
  ry: 2.126,
  fill: "#BBCEEE"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.159 13.237a2.12 2.12 0 0 1 2.114-2.126h1.633c3.025 0 5.478 2.466 5.478 5.508 0 3.041-2.453 5.507-5.478 5.507h-5.093A2.12 2.12 0 0 1 14.7 20a2.12 2.12 0 0 1 2.114-2.125h5.093c.69 0 1.25-.563 1.25-1.256 0-.694-.56-1.256-1.25-1.256h-1.633a2.12 2.12 0 0 1-2.114-2.126Z",
  fill: "#BBCEEE"
})));
export default SvgCoursePreview;